module.exports = __webpack_public_path__ + "img/7 – 1.e9a2868d.png";